module.exports = __webpack_public_path__ + "media/images/phone-045cb83b917e42496b5d6036954d7a56.png";